import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Helmet } from "react-helmet";

const OurServices = () => {
  const pageTitle = "Our Services";

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
      </Helmet>
      <style>{`
        .our-services-hero {
          padding: 32px 0 8px;
          overflow: hidden;
        }
        .our-services-hero .row {
          align-items: center;
          margin-left: 0;
          margin-right: 0;
        }
        .our-services-copy,
        .our-services-media {
          min-width: 0;
          float: none;
        }
        .our-services-copy h2 {
          color: #f26624;
          font-weight: 500;
          font-size: 28px;
          line-height: 1.2;
          margin: 0 0 16px;
          text-align: left;
        }
        .our-services-copy p,
        .our-services-body p,
        .our-services-body li {
          font-size: 15px;
          line-height: 1.7;
          color: #444;
          width: 100%;
          max-width: 100%;
          float: none;
          margin: 0 0 16px;
          overflow-wrap: anywhere;
        }
        .our-services-media {
          margin-top: 8px;
        }
        .our-services-video {
          display: block;
          width: 100% !important;
          max-width: 100%;
          height: 300px;
          object-fit: cover;
          margin: 0 !important;
          border: none;
          border-radius: 12px;
        }
        .our-services-body {
          background: #fbfbfb;
          padding: 28px 0 40px;
        }
        .our-services-body ul {
          list-style-type: disc;
          padding-left: 1.25rem;
          margin: 0 0 8px;
        }
        .our-services-body li {
          display: list-item;
          list-style-type: disc;
          margin-bottom: 12px;
        }
        @media (min-width: 576px) {
          .our-services-copy h2 { font-size: 34px; }
          .our-services-video { height: 360px; }
        }
        @media (min-width: 768px) {
          .our-services-hero { padding: 40px 0 12px; }
          .our-services-copy h2 { font-size: 40px; }
          .our-services-copy p,
          .our-services-body p,
          .our-services-body li { font-size: 16px; }
          .our-services-video { height: 420px; border-radius: 0 0 0 28px; }
        }
        @media (min-width: 992px) {
          .our-services-hero { padding: 56px 0 20px; }
          .our-services-copy h2 { font-size: 46px; line-height: 1.15; }
          .our-services-media { margin-top: 0; padding-left: 16px; }
          .our-services-video { height: 500px; border-radius: 0 0 0 39px; }
        }
        @media (min-width: 1200px) {
          .our-services-copy h2 { font-size: 52px; }
          .our-services-video { height: 540px; }
        }
      `}</style>
      <div className="main-content">
        <Header />

        <section className="our-services-hero">
          <div className="container">
            <div className="row g-4">
              <div className="col-12 col-lg-6 our-services-copy">
                <h2>OUR SERVICES</h2>
                <p>
                  Our Company’s core service offerings comprise brokerage
                  services derived from exclusive sales mandates or inventory
                  underwriting arrangements. Under this model, our Company
                  enters into agreements with real estate developers, securing
                  exclusive or semi-exclusive rights to market and sell
                  specific units within a project in return for brokerage
                  income. To obtain these rights, our Company provides an
                  advance to the developer, which is refunded upon the sale of
                  the allotted inventory or upon expiry of the mandate period.
                  The brokerage is generally determined based on a predefined
                  slab structure. This arrangement is commonly referred to as
                  inventory underwriting.
                </p>
              </div>
              <div className="col-12 col-lg-6 our-services-media">
                <video
                  className="our-services-video"
                  poster="assets/img/UNLEASHING.jpg"
                  src="/Video/unleasing.mp4"
                  autoPlay
                  preload="auto"
                  muted
                  playsInline
                  loop
                />
              </div>
            </div>
          </div>
        </section>

        <section className="our-services-body" id="offering">
          <div className="container">
            <div className="row">
              <div className="col-12 col-lg-10">
                <p>
                  Additionally, during Fiscal 2025, the Company earned revenue
                  of ₹200.00 lakhs from loan syndication activities. Furthermore,
                  our Company continues to explore opportunities to diversify
                  its revenue streams and enhance value delivery to its
                  customers.
                </p>
                <p>
                  In support of its core business operations, our Company
                  provides strategic advisory services to real estate
                  developers, encompassing product positioning, pricing
                  strategy, market research, and inventory structuring. These
                  value-added services are aimed at enhancing sales velocity and
                  improving market penetration. While our Company does not earn
                  direct revenue from such services, they play a crucial role in
                  strengthening its relationships with the developers and their
                  retention by offering a comprehensive range of solutions under
                  one roof.
                </p>
                <p>
                  Our Company operates on a multi-stakeholder engagement model,
                  monetizing through:
                </p>
                <ul>
                  <li>
                    <strong>Brokerage for Exclusive Sale Arrangements:</strong>{" "}
                    Brokerage or Commission margin on the sale of
                    underwritten/exclusively mandated inventories.
                  </li>
                  <li>
                    <strong>Loan Syndication Services &amp; Advisory:</strong>{" "}
                    Commission or success fees for arranging developer and buyer
                    financing and providing advisory and consulting services in
                    primary market.
                  </li>
                  <li>
                    <strong>Real Estate Development:</strong> Investment in Real
                    Estate Development business through Group Entities operating
                    in Tier -II cities in India.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
};

export default OurServices;
